import InfoCircle from '@/assets/icons/alert-circle.svg?react';
import InfoHexagon from '@/assets/icons/alert-hexagon.svg?react';
import InfoSquare from '@/assets/icons/alert-square.svg?react';
import Check from '@/assets/icons/check.svg?react';
import XClose from '@/assets/icons/x-close.svg?react';
import Live from '@/assets/icons/signal-01.svg?react';

export const statusChipText = {
  info: 'Info',
  warning: 'Warning',
  error: 'Error',
  success: 'Success',
  resolved: 'Resolved',
  unresolved: 'Unresolved',
  live: 'Live',
};

export const chipIcon = {
  info: InfoCircle,
  success: InfoSquare,
  error: InfoHexagon,
  warning: InfoHexagon,
  resolved: Check,
  unresolved: XClose,
  live: Live,
};
